import app from '../index';

export default app('prod');
